import { CodeSpaceCombinedProps } from './types';

const usePresenter = (props: CodeSpaceCombinedProps): CodeSpaceCombinedProps => {
  return props;
};

export default usePresenter;
